import {CSSProperties, FC, ReactElement} from 'react';
import './Loading.less';

export type LoadingProps = Partial<{
    id?: string,
    center: boolean,
    inline: boolean,
    message: string | ReactElement,
    pct: number, // Percentage complete (0-100),
    zoom: number,
}>;

const Loading: FC<LoadingProps> = props => {
    const center = props.center === undefined ? true : props.center;

    const zoom = props.zoom ?? .3;

    const style: CSSProperties = {};
    if (props.inline) {
        style.zIndex = 1001;
        style.zoom = zoom;
        style.margin = '0';
        style.height = 'unset';
        style.width = 'unset';
        style.display = 'block';
    }

    if (center) style.margin = 'auto';
    else {
        style.margin = '1em';
        style.height = 'fit-content';
    }

    return (
        <div id={props.id || 'SpinnerContainer'}
             className="Loading"
             style={style}
        >
            <div className="Spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className='Loading__message'>{props.message}</div>
            {props.pct > 0 && <progress value={props.pct}/>}
        </div>
    );

}

export default Loading;
